import React from "react";
import { CircularProgress, Divider } from "@material-ui/core";
import ModalCrearReferente from "../components/Glosario/ModalCrearReferente";
import useGetReferentes from "../hooks/useGetReferentes";
import TablaReferente from "../components/Glosario/TablaGlosario";
import { useSelector } from "react-redux";

const TablaReferentesContainer = () => {
  const { loading } = useGetReferentes();

  const data = useSelector((state) => state.glosarios.value);
  const data2 = useSelector((state) => state.unidad.value);

  if (loading) {
    return (
      <>
        <br />
        <br />
        <div className="d-flex justify-content-center">
          <CircularProgress color="inherit"></CircularProgress>
        </div>
      </>
    );
  }
  return (
    <div>
      <div>
        <ModalCrearReferente />
        <Divider />
      </div>
      <div>
        <Divider />
        <TablaReferente datosTabla={data} isLoading={loading} data2={data2} />
      </div>
    </div>
  );
};

export default TablaReferentesContainer;
